import React, {Component} from "react";
import "./Upload.css"
import Authentication from "../../authentication/Authentication";
import Api from "../../api/Api";
import {toast} from "react-toastify";

export default class Upload extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showRestoreButton: false,
            checked: "",
            bucketInfo: {},
            showLoading: false,
            showRestoreMessage: false,
            selectedFile: null,
            showUploading: false,
            showErrorMessage: false,
            showInfoMessage: false
        };

        this.authentication = new Authentication();
    };

    componentDidMount() {
        this.props.refresh()
        this.backupRefreshInterval = setInterval(this.props.refresh, 10000);
    }

    componentWillUnmount() {
        if (this.backupRefreshInterval) {
            clearInterval(this.backupRefreshInterval);
        }
    };

    handleFileChange = (e) => {
        this.setState({
            selectedFile: e.target.files[0]
        })
    }

    handlePost() {
        this.setState({
            showUploading: false,
            showInfoMessage: true
        })
    }

    handleError() {
        this.setState({
            showErrorMessage: true
        })
    }
    usePreSignedPost = (url) => {
        const params = {
            Key: `/${this.props.domain}/${this.state.selectedFile.name}`,
            ContentType: this.state.selectedFile.type,
            ACL: 'public-read'
        }

        const formData = new FormData()
        Object.keys(params).forEach((key) => {
            formData.append(key, params[key]);
        });
        formData.append('file', this.state.selectedFile);

        fetch(url.url, {
            method: 'POST',
            body: formData
        }).then(() => this.handlePost()).catch((error) => this.handleError())
    }

    handleRestore = (bucketInfo) => {
        const api = new Api();

        this.setState({
            checked: "",
            bucketInfo: {},
            showLoading: true,
            showRestoreMessage: true
        })

        if (this.authentication.isAdmin()) {
            api.pisaasRestore(() => console.log("Successful restore"), function (err) {
                console.log(err);
                toast.error("Failed to fetch Pisaas Instances", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }, this.props.domain, bucketInfo['VersionId'], this.props.pisaasInstanceId, this.props.packageId, this.props.region);
        }

    }

    handleUploadClick = (e) => {
        e.preventDefault()

        if (this.state.selectedFile) {
            this.setState({
                showUploading: true
            })

            if (!this.state.selectedFile) {
                return;
            }

            const api = new Api()

            const fileName = this.state.selectedFile.name

            if (this.authentication.isAdmin()) {
                api.pisaasCreateS3PresignedPost(this.usePreSignedPost, function (err) {
                    console.log(err);
                    toast.error("Failed to fetch Pisaas Instances", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }, this.props.domain, fileName, "pisaas-repos-upload", this.props.region);
            }
        }
    }


    formatDate = (date) => {
        return date.split("+")[0]
    }

    handleCheckboxClick = (e, backup) => {
        if (this.formatDate(backup["LastModified"]) === this.state.checked) {
            this.setState({
                checked: "",
                bucketInfo: {}
            })
        } else {
            this.setState({
                checked: this.formatDate(backup["LastModified"]),
                bucketInfo: backup
            })
        }
    }


    render() {
        return (
            <>
                <div>
                    <h2 className={"config-header"} data-testid="config.header.upload">Upload Repos</h2>
                    <ul>
                        <li>Upload a dashboard repo to restore on your instance</li>
                        <li>Select which version you would like to restore</li>
                    </ul>
                    <p>Select a SQL file to restore:</p>
                    <div className={"upload-container"} data-testid="config.upload">
                        <label className={"choose-file-button"}  data-testid="config.upload.chooseFile">
                            {this.state.selectedFile ? this.state.selectedFile.name : "Choose file"}
                            <input className={"choose-file-input"} accept={".sql"} type={"file"}  data-testid="config.upload.input.file"
                                   onChange={(e) => this.handleFileChange(e)}/>
                        </label>
                        {this.state.showUploading ? <i className="fa fa-spinner fa-pulse fa-3x fa-fw upload-loading"/> : <button className={"upload-button"}  data-testid="config.upload.button.upload" onClick={(e) => this.handleUploadClick(e)}>Upload</button>}
                    </div>
                    {this.state.showErrorMessage ? <p data-testid="config.upload.error">Something has gone wrong when uploading your file. Please try again later.</p> : <></>}
                    {this.state.showInfoMessage ? <p data-testid="config.upload.info">Your file is being validated. If it passes our checks it will appear here in a few seconds.</p> : <></>}
                    <div className={"gap-top-3"}>
                        <p className={"field-name"}  data-testid="config.upload.uploads">Uploads: </p>
                        <ul>
                            {this.props.backups.map((backup, index) => {
                                if (backup.tags.length >= 1) {
                                    return (
                                        <div className={"backup-row"} data-testid="config.upload.backup.row" key={index}>
                                            <input onChange={(e) => this.handleCheckboxClick(e, backup['backup'])}
                                                   checked={this.state.checked === this.formatDate(backup['backup']["LastModified"])}
                                                   type={"checkbox"} className={"checkbox"} data-testid="config.upload.backup.checkbox"/>
                                            <p className={"backup-date"} data-testid="config.upload.backupDate">{this.formatDate(backup['backup']["LastModified"])}</p>
                                            <p className={"backup-date"} data-testid="config.upload.backupTag"> - {backup.tags[0].Value}</p>
                                        </div>
                                    )
                                } else {
                                    return (
                                        <></>
                                    )
                                }
                            })}
                        </ul>
                        {this.state.checked ? <button onClick={(e) => this.handleRestore(this.state.bucketInfo)}
                                                      className={"try-pi-btn btn-create"} data-testid="config.upload.button.restore">RESTORE</button> : this.state.showLoading ?
                            <i className="fa fa-spinner fa-pulse fa-3x fa-fw loading restore-loading"/> : <></>}
                        {this.state.showRestoreMessage ?
                            <p data-testid="config.upload.restore.message">The restore process has begun. Please allow 10 minutes for this to complete</p> : <></>}
                    </div>
                </div>
            </>
        )
    }
}



